<template>
    <div class="container" id="payment-content" :style="{backgroundColor: Theme['gray-100']}">
        <div class="content">
            <div id="payment-content1">
                <div class="d-flex justify-content-between mb-8">
                    <div class="text-start pe-5">
                        <h5>{{ company?.society?.name?.toUpperCase() }}</h5>
                        <p>{{ company?.society?.address }} , {{ company?.society?.city }}, {{ company?.country?.name }}
                            <br>{{ company?.society?.society_email }}
                            <br>{{ company?.society?.society_phone }} 
                        </p>
                        <p v-if="company?.society?.ifu_number"><span class="fw-bolder">{{ $t('ifu') }}</span> : {{ company?.society?.ifu_number }}</p>
                        <p v-if="company?.society?.rccm_number"><span class="fw-bolder">{{ $t('rccm') }}</span> : {{ company?.society?.rccm_number }}</p>                        
                        <h4>{{ ($t('payment.advance_invoice') + ' : ' + advancePayment?.advance_number) }}</h4>
                        <p class="otherStyle mt-3">{{ $t('invoices.date_creation') + ' : ' + formatDate(new Date(advancePayment?.invoice?.invoice_date)) }}</p>
                    </div>
                    <div class="text-end" style="text-align: right;">
                        <div class="py-10 mb-5" v-if="company?.society?.logo_url">
                            <img :src="company?.society?.logo_url" alt="Logo" style="width: 100px; height: auto;">
                        </div>
                        <p>{{$t('invoices.to')}}
                            <br><span class="fw-bolder">{{ advancePayment?.invoice?.contact?.fullname }}</span>
                            <br>{{ contactPhone }}
                            <br>{{ advancePayment?.invoice?.contact?.email }}
                        </p>
                    </div>
                </div>

                <div style="min-height: 400px;">
                    <div class="table-responsive">
                        <table class="table text-center mb-5">
                            <thead>
                                <tr>
                                    <th>N°</th>
                                    <th>{{$t('invoices.description')}}</th>
                                    <th>{{$t('invoices.qty')}}</th>
                                    <th>{{$t('invoices.price')}}</th>
                                    <th>{{$t('invoices.rem')}}</th>
                                    <th>{{$t('invoices.taxes')}}</th>
                                    <th>{{$t('invoices.amount')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <Item v-for="(item, index) in advancePayment?.invoice?.items" :key="index" :item="item" :index="index" :currency="advancePayment?.invoice?.currency?.symbol"/>
                            </tbody>
                        </table>
                    </div>

                    <div class="d-flex justify-content-between otherStyle">
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.totalTax') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(advancePayment?.invoice?.invoice_total_tax))  }} {{ advancePayment?.invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                        <div class="spacer"></div>
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.subtotal') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(advancePayment?.invoice?.sub_total))  }} {{ advancePayment?.invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between py-3 otherStyle">
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.totalRem') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(advancePayment?.invoice?.invoice_discount_value))  }} {{ advancePayment?.invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                        <div class="spacer"></div>
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.totalTtc') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(advancePayment?.invoice?.total))  }} {{ advancePayment?.invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <div class="flex-item py-5 otherStyle flex-column" >
                        </div>
                        <div class="spacer"></div>
                        <div class="flex-item py-5 flex-column" style="background-color: var(--bs-primary); color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.total') }}
                                </div>
                                <div class="text-start pe-6">
                                {{ $formatLocalAmount(parseFloat(advancePayment?.invoice?.total))  }} {{ advancePayment?.invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <table class="table text-center mb-5">
                        <thead>
                            <tr>
                                <th>N°</th>
                                <th class="text-start">{{$t('payment.advance')}}</th>
                                <th class="text-end pe-6">{{$t('invoices.amount')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ formattedAdvanceNumber }}</td>
                                <td class="text-start">{{$t('crm.payments.advance_ref', { number: advancePayment.advance_number, percentage: advancePayment.percentage })}}%</td>
                                <td class="text-end pe-6">{{ $formatLocalAmount(parseFloat(advancePayment?.amount))  }} {{ advancePayment?.invoice?.currency?.symbol }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div id="payment-content2">
              <section>
                <p><strong> {{ $t('payment.remaining_amount') }}  : {{  advancePayment?.remaining_amount }}   {{ advancePayment?.invoice?.currency?.symbol }} </strong> </p>
              </section>
                <div class="d-flex justify-content-between mt-10" v-if="advancePayment?.invoice?.paymentCondition && advance">
                    <div class="text-start">
                        <h4 style="color: #F07817;">{{ $t('invoices.terms') }}</h4>
                        <div>
                            <span v-if="advancePayment?.invoice?.paymentCondition?.name" style="font-weight: 500;">{{$t('crm.estimate.label.paymentCondition')}} : {{ advancePayment?.invoice?.paymentCondition?.name }}</span>
                            <br><span v-if="advancePayment?.invoice?.paymentType?.name" style="font-weight: 500;"> {{$t('crm.estimate.label.paymentType')}} : {{ advancePayment?.invoice?.paymentType?.name }} </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mb-2 pt-5" id="payment-content3" :style="{borderTop: '1px solid '+Theme['gray-300']}">
            <div class="d-flex text-start mb-3">
                <span class="fw-bold me-2" v-if="company?.society?.headquarters_address">{{ $t('company.label.headquarters_address') }}: {{ company?.society?.headquarters_address }} / </span>
                <span class="fw-bold" v-if="company?.society?.address">{{ company?.society?.address }}</span>
                <span class="fw-bold me-1" v-if="company?.society?.city">, {{ company?.society?.city }} </span>
                <span class="fw-bold" v-if="company?.country?.name"> {{ company?.country?.name }}</span>
                <span class="fw-bold" v-if="company?.website"> / {{ company?.website }}</span>
            </div>
            <div class="d-flex text-start">
                <span v-if="company?.bankData?.bank_name" class="fw-bold me-2">{{ company?.bankData?.bank_name }} </span>
                <span v-if="company?.bankData?.bic" class="fw-bold me-2">{{ $t('bank.label.bic')?.toUpperCase() }}: {{ company?.bankData?.bic }} </span>
                <span v-if="company?.bankData?.rib" class="fw-bold me-2">{{ $t('bank.label.rib')?.toUpperCase() }}: {{ company?.bankData?.rib }} </span>
                <span v-if="company?.bankData?.iban" class="fw-bold">{{ $t('bank.label.iban')?.toUpperCase() }}: {{ company?.bankData?.iban }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { Theme } from "@/composables/theming";
    import {computed, defineProps} from 'vue'
    import {useStore} from "vuex";
    import {formatDate, $formatLocalAmount} from "@/mixins/Helpers";
    import Item from "./Item";

    const props = defineProps({
        advance: {type: Boolean, default: false},
        advancePayment: { type: Object, required: true }
    })
    const store = useStore()

    const company = computed(() => store.getters['company/getCompanyInfos'])

    const contactPhone = computed(() => {
        if(props.advancePayment?.invoice?.contact) {
            const phones = props.advancePayment?.invoice?.contact?.phone
            if(phones.length)
            return phones[0]
            return ""
        }
        return ""
    })
    const formattedAdvanceNumber = computed(() => {
      if (!props.advancePayment.advance_number) return 'N/A';

      const parts = props.advancePayment.advance_number.split('-');
      const lastPart = parts.pop(); // Gets "ADV-01"
      const numberPart = lastPart.split('-').pop(); // Gets "01"

      return numberPart;
    });
</script>

<style scoped>
  .container {
    width: 100%;
    max-width: 800px;
    margin: 20px auto;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
  }
  .table th {
    background-color: var(--bs-primary);
    color: #ffffff;
  }
  .table tr {
    background-color: #fff;
    margin-bottom: 5px;
    border-bottom: 3px solid #F2F3F4;
  }
  .otherStyle{
      font-weight: 500;
  }
  .img_class{
      border: 2px dashed var(--bs-primary);
  }
  .flex-item {
       flex: 1;
   }
   .spacer {
       min-width: 20px;
   }
</style>